import { z } from 'zod';

/**
 * Shared Zod enums for the user status + DM-privacy values. The server's
 * request schemas validate against these, and the cross-app `UserStatus` /
 * `DmPrivacy` types are derived from them (see types/index.ts) — so the wire
 * values, the validation, and the TypeScript unions can never drift apart.
 */
export const userStatusSchema = z.enum(['ONLINE', 'IDLE', 'DND', 'OFFLINE', 'INVISIBLE']);
export const dmPrivacySchema = z.enum(['EVERYONE', 'FRIENDS', 'NOBODY']);
